
import Vue from 'vue'
import Logs from '@/components/stats/Logs.vue'
import Statistics from '@/components/stats/Statistics.vue'

type Tab = 'logs' | 'usage'

type ActivityTabsData = {
  activeTab: Tab
}

export default Vue.extend({
  name: 'UserActivityTabs',
  props: {
    usage: {
      type: Array, // TODO as PropType<...>
      required: true,
    },
    user: {
      type: Object, // TODO as PropType<...>
      required: true,
    },
    selected: {
      type: Object, // TODO as PropType
      required: true,
    },
    loadingUsage: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Logs,
    Statistics,
  },
  data(): ActivityTabsData {
    return {
      activeTab: 'logs',
    }
  },
  methods: {
    pickTab(name: Tab) {
      this.activeTab = name
    },
  },
})
